/* eslint-disable no-unused-vars */
import React, { useCallback } from 'react';
import { IconButton, ChooseAudienceManagement } from 'components';
import { Pen } from 'assets/icons';
import { useComputed, useSignal } from '@preact/signals-react';

export const EditAudienceBtn = () => {
  const isOpenModal$ = useSignal(false);

  const handleModalAction = useCallback((newModalPosition) => {
    isOpenModal$.value = newModalPosition;
  });

  return (
    <>
      <IconButton.SmallSize
        style={{ marginLeft: 'auto', marginRight: 'auto' }}
        isDefaultMuted
        icon={Pen}
        type={IconButton.btnTypes.tertiary}
        onClick={() => handleModalAction(true)}
      />
      {useComputed(
        () =>
          isOpenModal$.value && (
            <ChooseAudienceManagement
              closeModal={() => handleModalAction(false)}
              isOpenModal$={isOpenModal$}
            />
          ),
      )}
    </>
  );
};
